























































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import PointerMenu from "./PointerMenu.vue";
import Loading from "./Loading.vue";

import { EventDateDesiredJson } from "../../shared/EventDateJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

export default Vue.extend({
  name: "FormDateTimeBeginEnd",
  components: {
    PointerMenu,
    Loading,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    data: Object as PropType<EventDateDesiredJson>,
    editable: Boolean,
    hideInputs: {
      type: Array,
      default() {
        return [];
      },
    },
    requiredInputs: {
      type: Array,
      default() {
        return [];
      },
    },
    customValidationKey: {
      type: String,
      default() {
        return "dates";
      },
    },
    customId: {
      default: "0",
    },
    validation: Object,
    submitValidation: Boolean,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      details: null as EventDateDesiredJson | null,
      cachedDates: {} as {
        beginDateTime: string;
        endDateTime: string;
        beginTime: string;
        endTime: string;
      },
      toValidate: {} as any,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.setCachedData();
  },
  methods: {
    init() {
      this.details = { ...this.data };
      this.setCachedData();
    },

    setCachedData() {
      this.setCachedDates();
    },

    //START set cached data

    setCachedDates() {
      if (this.details != null) {
        this.cachedDates = {
          beginDateTime: "",
          endDateTime: "",
          beginTime: "",
          endTime: "",
        };

        if (this.details.beginDateTime != "") {
          var d = new Date(this.details.beginDateTime);

          this.cachedDates.beginDateTime = DateFormatter.formatISODate(d);
          this.cachedDates.beginTime = DateFormatter.formatTime(d);
        }

        if (this.details.endDateTime != "") {
          var d = new Date(this.details.endDateTime);

          this.cachedDates.endDateTime = DateFormatter.formatISODate(d);
          this.cachedDates.endTime = DateFormatter.formatTime(d);
        }
      }
    },

    //END set cached data

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      this.$emit("validateInput", this.customValidationKey, key);

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //START set input data (where data be cached)

    setDates() {
      if (this.details != null) {
        let k = this.cachedDates;
        let i: keyof typeof k;

        for (i in k) {
          if (this.cachedDates.endDateTime == "") {
            this.cachedDates.endDateTime = this.cachedDates.beginDateTime;
          }

          var beginDate = "";
          var endDate = "";

          //beginDateTime
          beginDate = DateFormatter.formatUSDate(new Date(this.cachedDates.beginDateTime));

          //endDateTime
          endDate = DateFormatter.formatUSDate(new Date(this.cachedDates.endDateTime));

          //beginDateTime Time
          if (isNaN(new Date(beginDate).getTime())) {
            this.details.beginDateTime = "";
          } else {
            let beginDateTime = new Date(beginDate);

            if (this.cachedDates.beginTime != "") {
              beginDateTime = new Date(beginDate + " " + this.cachedDates.beginTime);
            }

            this.details.beginDateTime = DateFormatter.formatISODateTime(beginDateTime);

            this.cachedDates.beginTime = DateFormatter.formatTime(beginDateTime);
          }

          //endDateTime Time
          if (isNaN(new Date(endDate).getTime())) {
            this.details.endDateTime = "";
          } else {
            let endDateTime = new Date(endDate);

            if (this.cachedDates.endTime != "") {
              endDateTime = new Date(endDate + " " + this.cachedDates.endTime);
            }

            this.details.endDateTime = DateFormatter.formatISODateTime(endDateTime);

            this.cachedDates.endTime = DateFormatter.formatTime(endDateTime);
          }
        }
      }
    },

    formatDateTimes() {
      //begin
      let beginTime = this.cachedDates.beginTime.replace(/\D/g, "").replace(/^(\d{2,2})/g, "$1:");

      if (beginTime.match(/^\d{2,2}:\d{2,2}$/g)) {
        this.cachedDates.beginTime = beginTime;
      }

      //end
      let endTime = this.cachedDates.endTime.replace(/\D/g, "").replace(/^(\d{2,2})/g, "$1:");

      if (beginTime.match(/^\d{2,2}:\d{2,2}$/g)) {
        this.cachedDates.endTime = endTime;
      }
    },

    //END set input data (where data be cached)

    checkHideInput(inputs: string[]) {
      return !inputs.some((i) => !this.hideInputs.includes(i));
    },
  },

  watch: {
    data: function () {
      this.details = this.data;
      this.setCachedData();
    },

    details: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.$emit("change", this.details);
        }
      },
      deep: true,
    },

    /* submitValidation: function () {
      if (this.submitValidation) {
        if (this.details != null) {
          this.validation = validateSepaMandate(this.details);
        }
      }
    }, */
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },
  },
});
